import type { RapidWorkflowDataType } from "@rapid/components/flow/shared/Deploy/documentation/types";

export const workflowAcceptsConfidence = (workflow?: RapidWorkflowDataType | null): boolean => {
    if (!workflow?.config) return false;

    try {
        const parsedConfig = JSON.parse(workflow.config);
        const inputs = parsedConfig?.specification?.inputs;

        return Array.isArray(inputs) && inputs.some((input) => input?.name === "confidence");
    } catch (error) {
        console.warn("Failed to parse workflow config while checking confidence input", error);
        return false;
    }
};
